import { Tag, Text } from "@zapier/design-system";
import styles from "./DraftBanner.module.css";

interface DraftBannerProps {
  message?: string;
}

export const DraftBanner: React.FC<DraftBannerProps> = ({
  message = "You're previewing a draft. Creating it will generate the assets in your Zapier account.",
}) => {
  return (
    <div className={styles.wrapper}>
      <Tag size="small" variant="warning">
        Draft
      </Tag>
      <div>
        <Text color="TextWeaker" type="Body1Multiline">
          {message}
        </Text>
      </div>
    </div>
  );
};

export default DraftBanner;
